document.addEventListener('DOMContentLoaded', function () {
  const slides = Array.from(document.querySelectorAll('.announcement--slide'));

  // 中身があるスライドだけ抽出（空・空白は除外）
  const validSlides = slides.filter(slide =>
    slide.textContent.trim().length > 0
  );

  // 有効なスライドが1つ以下なら何もしない
  if (validSlides.length <= 1) return;

  let current = 0;

  // 初期表示を整理（念のため）
  slides.forEach(slide => (slide.style.display = 'none'));
  validSlides[0].style.display = 'block';

  setInterval(() => {
    validSlides[current].style.display = 'none';
    current = (current + 1) % validSlides.length;
    validSlides[current].style.display = 'block';
  }, 6000);
});